import React from 'react';
import { type ISearchContextShape } from '../../types/searchResultsType';

export const SearchContext = React.createContext<ISearchContextShape | null>(null);

export default SearchContext;
